import React from "react"
import tw from "twin.macro"

import { ReactComponent as TickIcon } from "../../../assets/_global/icons/ic_tick.svg"

const CompChartRow = (props) => {
    return (
        <li>
            <div css={tw`flex flex-wrap lg:flex-no-wrap`}>
                <div
                    css={tw`text-center lg:text-left w-full bg-white pt-4 lg:py-4 px-4 lg:pl-8 lg:max-w-xl border-t border-l-0  border-r-0 border-b-0 border-solid border-grey-300`}
                    dangerouslySetInnerHTML={{
                        __html: props.text,
                    }}
                >
                </div>
                <div
                    css={tw`w-1/3 lg:w-4/12 flex items-center justify-center bg-white py-4 px-4 border-t-0 lg:border-t border-solid border-grey-300 border-l-0 border-r-0 border-b-0 max-w-sm`}
                >
                    {props.ss && (
                        props.tick ? (
                            <TickIcon css={tw`-mt-4 w-8 h-8 fill-current text-green-400`} />
                        ) : (
                            <span
                            css={tw`w-5 h-5 bg-green-200 rounded-full`}
                            css={!props.crown && tw`bg-green-400`}
                            ></span>
                        )
                    )}
                </div>
                <div
                    css={tw`w-1/3 lg:w-4/12 flex items-center justify-center bg-white py-4 px-4 border-t-0 lg:border-t border-solid border-grey-300 border-l-0 border-r-0 border-b-0 max-w-sm`}
                >
                    {props.es && (
                        props.tick ? (
                            <TickIcon css={tw`-mt-4 w-8 h-8 fill-current text-green-400`} />
                        ) : (
                            <span
                            css={tw`w-5 h-5 bg-teal-300 rounded-full`}
                            css={!props.crown && tw`bg-green-400`}
                            ></span>
                        )
                    )}
                </div>
                <div
                    css={tw`w-1/3 lg:w-4/12 flex items-center justify-center bg-white py-4 px-4 border-t-0 lg:border-t border-solid border-grey-300 border-l-0 border-r-0 border-b-0 max-w-sm`}
                >
                    {props.pl && (
                        props.tick ? (
                            <TickIcon css={tw`-mt-4 w-8 h-8 fill-current text-green-400`} />
                        ) : (
                            <span
                            css={tw`w-5 h-5 bg-green-500 rounded-full`}
                            css={!props.crown && tw`bg-green-400`}
                            ></span>
                        )
                    )}
                </div>
            </div>
        </li>
    )
}

export default CompChartRow